<template>
    <div class="vue-modal-wrapper">
        <button class="modal-button" @click="show">
            <i v-if="buttonIcon" :class="buttonIcon"></i>
            {{ buttonText }}
        </button>
        <modal :id="modalId" :name="modalId" width="90%" :maxWidth="950" :adaptive="true" height="auto" :scrollable="true" @before-close="handleClose">
            <div class="modal-inner-wrapper">
                <a class="close-button" href="" @click.prevent="close"><i class="icon-close-thin"></i></a>
                <h3>{{ modalTitle }}</h3>
                <div class="modal-slot-wrapper">
                    <slot></slot>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import modalMixin from "../mixins/modalMixin";

export default {
    name: "ModalWrapper",

    props: ['buttonIcon', 'buttonText', 'modalTitle'],

    mixins: [modalMixin],

    computed: {
        modalId() {
            return _.uniqueId('modal-wrapper-');
        }
    }
}
</script>
